module.exports = __webpack_public_path__ + "img/img-tb-aluno.80d3f302.png";